/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown> }} Notifications_Message_Subject_Lowest_PriceInputs */

const he_notifications_message_subject_lowest_price = /** @type {(inputs: Notifications_Message_Subject_Lowest_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`הנמוך ביותר: ${i?.itemName}`)
};

const en_notifications_message_subject_lowest_price = /** @type {(inputs: Notifications_Message_Subject_Lowest_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lowest ever: ${i?.itemName}`)
};

/**
* | output |
* | --- |
* | "Lowest ever: {itemName}" |
*
* @param {Notifications_Message_Subject_Lowest_PriceInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_subject_lowest_price = /** @type {((inputs: Notifications_Message_Subject_Lowest_PriceInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Subject_Lowest_PriceInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_subject_lowest_price(inputs)
	return en_notifications_message_subject_lowest_price(inputs)
});